import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@airbus/components-react/components/Modal'
import Button from '@airbus/components-react/components/Button'
import MessageBlock from 'pages/Orders/components/messageBlock'
import LightDarkContext from 'context/LightDarkModeContext'
import { Message } from 'constants/message'
import Container from '@airbus/components-react/components/Container'
import { FormProvider, useForm } from 'react-hook-form'
import { Inline, Stack } from '@airbus/components-react/components'
import PageHeader from 'components/pageHeader'
import { OrderValidator } from 'types/order'
import FormSelect from 'components/FormFields/FormSelect'

type Props = {
  idCommand: string
  listValidators: OrderValidator[]
  message?: Message
  isOpened: boolean
  onCloseModal: () => void
  onSubmitNextValidator: (nv: string) => void
}

type Inputs = {
  selectedValidator: string
}

const styleModal = {
  position: 'absolute',
  transform: 'translate(50%, 50%)',
  width: '50%',
  height: '16em',
  border: '2px solid #000',
  boxShadow: 24,
  overflowY: 'scroll',
  scrollbarWidth: 'none',
}

/**
 * Modal window which prompts for a reason (or whatsoever, simply said an input field) and returns the input to the caller via its onSubmitReason handler
 * @param {*} props
 * @returns the input to the caller via its onSubmitReason handler
 */
const ModalNextValidator = ({
  idCommand,
  listValidators,
  message,
  isOpened,
  onCloseModal,
  onSubmitNextValidator,
}: Props) => {
  const { t } = useTranslation()

  const methods = useForm<Inputs>({
    defaultValues: { selectedValidator: '' },
  })
  const { handleSubmit, resetField } = methods

  const handleSubmitNextValidator = async (data: Inputs) => {
    onSubmitNextValidator(data.selectedValidator)
  }

  useEffect(() => {
    resetField('selectedValidator')
  }, [isOpened])

  const { getBackgroundColor } = useContext(LightDarkContext)

  return (
    <Modal
      open={isOpened}
      onClose={onCloseModal}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <div style={{ ...styleModal, backgroundColor: getBackgroundColor() }}>
        <>
          <PageHeader
            pageTitle={t('9500152').replace('{0}', idCommand)}
            modalEmbedded={true}
            modalOnClose={onCloseModal}
            style={{ top: 0 }}
          />

          <Container style={{ flex: 1 }} fixed>
            <div style={{ padding: '1em' }}>
              <FormProvider {...methods}>
                <form style={{ marginTop: '1em' }} onSubmit={handleSubmit(handleSubmitNextValidator)}>
                  <Stack>
                    {message ? <MessageBlock message={message} /> : ''}

                    <div>{t('9500153')}</div>

                    <FormSelect
                      label={t('9500155')}
                      name='selectedValidator'
                      options={listValidators?.map((v) => ({
                        value: v.surCode,
                        label: '[' + String(v.niv) + '] ' + v.surName,
                      }))}
                    />
                  </Stack>

                  <div style={{ width: '100%' }}>
                    <Inline spacing='1-x' style={{ margin: '10px 0' }}>
                      <Button variant='secondary' tabIndex={0} onClick={onCloseModal}>
                        {t('8000569')}
                      </Button>
                      <Button variant='primary' type='submit' tabIndex={0} disabled={!methods.formState.isDirty}>
                        {t('8000202')}
                      </Button>
                    </Inline>
                  </div>
                </form>
              </FormProvider>
            </div>
          </Container>
        </>
      </div>
    </Modal>
  )
}

export default ModalNextValidator
